import { createNode } from '@glueapp/graph-types';
import { SlackIntegration } from './SlackIntegration';
import { Conversation, SlackChannelType } from './SlackTypes';

export const GetSlackChannels = createNode({
    id: 'Slack: Get Channels',
    name: 'Slack: Get Channels',
    description: 'Get the channels in the slack workspace',
    aiDescription:
        'Requires the Slack integration to be connected. Takes no inputs. Outputs a "Channels" port containing an array of channel objects from the connected Slack workspace, including both public and private channels.',
    category: 'Slack',
    color: '#4a154b',
    integration: SlackIntegration,
    inPorts: {},
    outPorts: {
        Channels: {
            kind: 'array',
            subType: SlackChannelType,
        },
    },
    isAsync: true,
    execute: async function (input) {
        function getChannels(cursor?: string) {
            return input.integration.callIntegration<{
                channels: Conversation[];
                response_metadata?: { next_cursor?: string };
            }>({
                url: 'https://slack.com/api/users.conversations',
                method: 'get',
                params: {
                    ...(cursor ? { cursor } : {}),
                    exclude_archived: true,
                    limit: 50,
                    types: ['public_channel', 'private_channel'],
                },
            });
        }

        async function pageThroughChannels(cursor?: string): Promise<Conversation[]> {
            const result = await getChannels(cursor);
            if (result.data) {
                if (result.data.response_metadata?.next_cursor) {
                    return [...result.data.channels, ...(await pageThroughChannels(result.data.response_metadata.next_cursor))];
                } else {
                    return result.data.channels;
                }
            } else {
                return [];
            }
        }

        const channels: Conversation[] = await pageThroughChannels();
        return { output: { Channels: channels as any } };
    },
});
